import './App.css';
import Footer from './Components/Footer';
import Hero from './Components/Hero';
import MiniProject from './Components/MiniProject';
import Nav from './Components/Nav';
import PartOne from './Components/PartOne';
import PartTwo from './Components/PartTwo';

function App() {
  return (
    <div>
      <Nav />
      <Hero />
      <PartOne />
      <PartTwo />
      <MiniProject />
      <Footer />
    </div>
  );
}

export default App;
